export enum EOptionMenuItemCallback {
  None = 'NONE',
  Delete = 'DELETE',
  Edit = 'EDIT',
  EditName = 'EDIT NAME',
  CopyLink = 'COPY LINK',
  Share = 'SHARE',
  AddField = 'ADD FIELD',
  Preview = 'PREVIEW',
  SaveAsTemplate = 'SAVE AS TEMPLATE',
  Settings = 'SETTINGS',
  Move = 'MOVE',
  MoveToTop = 'MOVE TO TOP',
  MoveUp = 'MOVE UP',
  MoveDown = 'MOVE DOWN',
  MoveToBottom = 'MOVE TO BOTTOM',
}
